<template>
    <div class="body">
        <p  class="p1" style="padding-top: 8vh;">📚 漫步学海，回望岁月</p>
        <p class="p5">每一次投入与坚持，</p>
        <p class="p6">都在积累今天的你。</p>
        <p class="p7">在富学宝典平台上，</p>
        <p class="p6">2025年累计学习<a class="highlight" style="font-size: 30px;">{{ ReportData.time }}</a>天</p>
        <p class="p6">每一天都在为未来积累能量！</p>

        <p class="p7" style="padding-top: 2vh;text-align: center;">今年你在富学宝典上的学习成就</p>
        <div v-if="ReportData.playtime" class="list" style="margin-top: 2vh;">
            <p class="p6"> <i class="fa fa-clock-o fa-2x clock-icon"></i>累计学习<a class="highlight">{{ ReportData.playtime }}</a>小时</p>
        </div>
        <div v-if="ReportData.coursenumMon" class="list">
            <p class="p6"><i class="fa fa-book fa-2x clock-icon"></i>学习课程<a class="highlight">{{ ReportData.coursenumMon }}</a>门</p>
        </div>
        <div v-if="ReportData.creditvalueFxbd" class="list">
            <p class="p6"><i class="fa fa-trophy fa-2x clock-icon"></i>获得学分<a class="highlight">{{ ReportData.creditvalueFxbd }}</a>个</p>
        </div>
        <p v-if="ReportData.rate1 && ReportData.rate1 > 0" class="p5" style="padding-top: 2vh;text-align: center;">超越了<a class="highlight">{{ ReportData.rate1 }}%</a>同行小伙伴！</p>
    </div>
</template>
  
<script>

export default {
    props: [ "ReportData"],
    data() {
        return {

        }
    },
    mounted(){
     
    },
    methods:{
        
    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/25October/logo.png") right  top  no-repeat,
                /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
                url("../../assets/25Year/bg1.jpg")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 18px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
    font-size: 30px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
 
.p5, .p6, .p7, .p8{
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 16px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p7{
    margin-top: 20px;
}

.clock-icon {
    color: purple;  /* 白色 */
}
.list{
    display: flex;
    /* justify-content: center;  */
    align-items: center; 
    width: 70%;
    height: 7vh;
    margin: 0 auto;
    background-color: rgba(238, 152, 131, 0.8);
    margin-top: 1vh;
    border-radius: 10px;
    border: #fff solid 1px;
}
@media screen and (min-width: 786px) {
    .body {
        background: 
                    url("../../assets/25Year/pcbg.jpg")  no-repeat;
        background-size:cover;
        width: 100%;
        height: 100vh;
    }

    .p1,.p2, .p3, .p4 {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        font-size: 25px;
        color: #fff;
        font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
    }

    .highlight {
        font-size: 40px;
        color: purple;
        text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
        font-weight: bolder;
        font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
    }
 
    .p5, .p6, .p7, .p8{
        margin:0 auto;
        text-align: center;
        font-size: 20px;
        width: 92%;
    }

    .p5, .p7{
        margin-top: 20px;
    }

    .list{
        display: flex;
        /* justify-content: center;  */
        align-items: center; 
        width: 40%;
        height: 7vh;
        margin: 0 auto;
        background-color: rgba(238, 152, 131, 0.8);
        margin-top: 1vh;
        border-radius: 10px;
        border: #fff solid 1px;
    }
}
</style>